import React from 'react';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';

const propTypes = {
    label: PropTypes.string,
    value: PropTypes.string,
}

export default class CopyToClipWithSpan extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            copied:false,
            open:false,            
            data:[]
        };
        this.handleTooltipClose = this.handleTooltipClose.bind(this);
        this.handleTooltipOpen = this.handleTooltipOpen.bind(this);
    }

    handleTooltipClose(e){
        if(this.state.open == true){
            this.setState({open:false,copied:false});
        }
    };

    handleTooltipOpen(){
        if(this.state.open == false){
            this.setState({open:true});
        }
    };
    onCopy = () => {
        this.setState({copied: true});
    };
    
    render() {
        const {
            value,
            label
        } = this.props
        return (
            <>
              {value&&<CopyToClipboard onCopy={this.onCopy} text={value}>
                <Tooltip onClose={this.handleTooltipClose} onOpen={this.handleTooltipOpen} open={this.state.open} title={this.state.copied?"コピーしました":"コピーできます"}>
                    <span className="pointer copy_hilight">{label || value}
                    {value&&<i style={{marginLeft:"10px"}}className="fa fa-clone" />}
                    </span>
                </Tooltip>
              </CopyToClipboard>}
            </>
        );
    }
}
CopyToClipWithSpan.propTypes = propTypes;